import React from 'react';
import { isGhcBot } from 'src/utils/botUtils';
import { getIsCookieHasAnOption } from 'src/utils/cookiesController';
import CookiesBanner from './CookiesBanner';
import { KEY_COOKIE as mobileBannerCookie } from './MobileAppPopup/constants';
import MobileAppPopupContainer from './MobileAppPopup';
import TopMobileAppBannerContainer from '../TopMobileAppBanner';

interface BannerControllerProps {
  isMobile: boolean;
  isHomepage: boolean;
  isAppBannerEnabled: boolean;
  isCookieBannerDisabled?: boolean;
  isWhitelabel: boolean;
}

// показыаем куки баннер после баннеров в прил-ки, если они есть
export const BannerController = ({
  isMobile,
  isHomepage,
  isAppBannerEnabled,
  isCookieBannerDisabled,
  isWhitelabel,
}: BannerControllerProps) => {
  if (isGhcBot()) {
    return null;
  }

  const mobileBannerHiding = getIsCookieHasAnOption(
    mobileBannerCookie,
    'hiding',
  );

  const showCookiesBanner = (mobileBannerHiding && isMobile) || !isMobile;

  const shouldShowCookiesBanner =
    (showCookiesBanner && !isCookieBannerDisabled) || isWhitelabel;

  return (
    <>
      {shouldShowCookiesBanner && <CookiesBanner />}
      {isAppBannerEnabled && isMobile && isHomepage ? (
        <TopMobileAppBannerContainer />
      ) : null}
      {isAppBannerEnabled && isMobile ? <MobileAppPopupContainer /> : null}
    </>
  );
};
